export function getCards(state: any) {
	return state.cards;
}

export function getNumberOfCards(state: any) {
	const numberOfCards = (state.cards.cards || []).length;
	return numberOfCards;
}
